import { InformationsComponent } from "./styles"

export default function Informations({ children }: any) {
  return (
    <InformationsComponent>
      { children }
    </InformationsComponent>
  )
}

